"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 * Initialize an empty ListItemBlock
 */
function createListItemBlock(listItem) {
    if (listItem === void 0) { listItem = null; }
    return {
        startElement: listItem,
        endElement: listItem,
        insertPositionNode: null,
        listItemContainers: listItem ? [listItem] : [],
    };
}
exports.createListItemBlock = createListItemBlock;
//# sourceMappingURL=ListItemBlock.js.map